var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm text-muted text-center login-footer"},[_c('span',[_vm._v("登录即视为同意")]),_c('a',{staticClass:"link",attrs:{"href":"https://api.wanfangche.com/pages/agreement/"}},[_vm._v("《服务协议》")]),_c('span',[_vm._v("及")]),_c('a',{staticClass:"link",attrs:{"href":"https://api.wanfangche.com/pages/privacy/"}},[_vm._v("《隐私政策》")])])
}]

export { render, staticRenderFns }